import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Toast from 'vue-toastification';

//import tailwind
import './style.css';

//import alerts w/ toastification
import '/src/assets/css/vue-toastification.css';

//import fa icons
import '@fortawesome/fontawesome-free/css/all.css';

//import bootstrap css & js
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap";

import store from "./store";


store.dispatch('ui/initTheme');

createApp(App).use(router).use(store).use(Toast).mount("#app");

router.isReady().then(() => {
    setTimeout(() => document.documentElement.classList.remove('no-transitions'), 300);
});
